import React from 'react'

export default function ThinBorder(props) {

  const verticalAlignment = {
    background: "#D7D7D7", 
    width: "0.01rem",
    height: "100%",
    margin: "0rem 1rem"
  }
  const horizontalAlignment = {
    background: "#D7D7D7", 
    height: "0.01rem",
    width: "100%",
  }
  
  return (    
    props.alignment === "vertical" ? 
    <hr style={ verticalAlignment }/> :
    <hr style={ horizontalAlignment }/> 
  )
}
